import React from "react";
import { useNavigate } from "react-router-dom";

import "./Footer2.scss";
// import fb_icon from "../../assets/images/facebook.svg";
// import insta_icon from "../../assets/images/instagram.svg";
// import twt_ion from "../../assets/images/twitter.svg";
// import yt_icon from "../../assets/images/youtube.svg";
import logo from "../../assets/images/whitelogo.svg";
// import paymentIcon from "../../assets/images/paymenticon.svg";
// import UPI from "../../assets/images/UPI.svg";

const Footer2 = ({ selected }) => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer2">
      <div className="universal_footer ">
        <div className="social_media_icon pt-4">
          <div className="container" style={{ paddingBottom: "12px" }}>
            <div className="row padding_space">
              <div className="col-lg-3 clol-md-3">
                <div className="footer_logo">
                  <img src={logo} alt="white logo" width={150} height={75} />
                  {/* <div className="medie_icon d-md-flex desktop_content">
                    <span className="pl-0 pr-0" style={{ paddingLeft: 0 }}>
                      <img className="" src={insta_icon} alt="" />
                    </span>
                    <span>
                      <img src={fb_icon} alt="" />
                    </span>
                    <span>
                      <img src={twt_ion} alt="" />
                    </span>
                    <span>
                      <img src={yt_icon} alt="" />
                    </span>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-7 col-md-5">
                <div className="footer_row ">
                  <ul className="d-flex px-0">
                    <li
                      style={{
                        color: `${selected === "home" ? "#DB4B41" : "#ffffff"}`,
                        fontWeight: `${selected === "home" ? "700" : "300"}`,
                      }}
                      onClick={() => navigate("/home")}
                    >
                      My Account
                    </li>
                    {/* <li
                      style={{
                        color: `${
                          selected === "offers" ? "#DB4B41" : "#ffffff"
                        }`,
                        fontWeight: `${selected === "offers" ? "700" : "300"}`,
                      }}
                      onClick={() => navigate("/offers")}
                    >
                      Offers
                    </li> */}
                    <li
                      style={{
                        color: `${
                          selected === "tier-history" ? "#DB4B41" : "#ffffff"
                        }`,
                        fontWeight: `${
                          selected === "tier-history" ? "700" : "300"
                        }`,
                      }}
                      onClick={() => navigate("/tier-history")}
                    >
                      Tier Benefits
                    </li>
                    <li
                      style={{
                        color: `${
                          selected === "rewards" ? "#DB4B41" : "#ffffff"
                        }`,
                        fontWeight: `${selected === "rewards" ? "700" : "300"}`,
                      }}
                      onClick={() => navigate("/rewards-catalogue")}
                    >
                      Rewards
                    </li>
                    <li
                      style={{
                        color: `${
                          selected === "feedback" ? "#DB4B41" : "#ffffff"
                        }`,
                        fontWeight: `${
                          selected === "feedback" ? "700" : "300"
                        }`,
                      }}
                      onClick={() => navigate("/feedback")}
                    >
                      Feedback
                    </li>
                  </ul>
                  <p>
                    Welcome to DLF Malls – your ultimate shopping, dining, and
                    entertainment destination! Discover exclusive offers,
                    exciting events, and a world of rewards at DLF Malls.
                    Explore and enjoy a seamless shopping experience!
                  </p>
                </div>
              </div>
              {/* <div className="medie_icon  mobile_content">
                <span className="pl-0 pr-0" style={{ paddingLeft: 0 }}>
                  <img className="" src={insta_icon} alt="" />
                </span>
                <span>
                  <img src={fb_icon} alt="" />
                </span>
                <span>
                  <img src={twt_ion} alt="" />
                </span>
                <span>
                  <img src={yt_icon} alt="" />
                </span>
              </div> */}
              {/* <div className="col-lg-4 col-md-4">
                <div className="d-flex email-div">
                  <input
                    className="form-control newsletter_input"
                    type="text"
                    placeholder="Your Email"
                    aria-label="default input example"
                  />
                  <button className="newsletterbutton">Submit</button>
                </div>
                <div className="text-rigth pt-3">
                  <img src={UPI} alt="" />
                </div>
              </div> */}
            </div>
          </div>
          <div className="copyrigth">
            <p>
              <span className="high_light_text">
                ©{currentYear} DLF MALLS REWARDS{" "}
              </span>{" "}
              | All copyrights reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer2;
